import React from 'react';
import { CheckIcon, SunIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-primary/10 bg-background py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="15ddjbc9f61kl">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="1jcv8hsqmnguh">
        <h2 id="final-title" className="text-balance text-3xl font-bold tracking-tight text-foreground sm:text-4xl" data-id="element-60" data-mp="1jb22mfnu90nj">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1ec7inae4x61u">
            <SunIcon className="h-7 w-7 shrink-0 text-accent" aria-hidden="true" data-id="element-62" data-mp="1t2euh79mzqtk" /> {productBrand}
          </span>
          <span className="mt-2 block text-lg font-extrabold uppercase tracking-[.16em] text-accent sm:text-xl" data-id="element-63" data-mp="1o4n1sb1640ob">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-64" data-mp="1x5l14g0nvk0k">
          Created by solar energy specialists for professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="s4fo26tjsh7u">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-66" data-mp="x64x5gx7mkta">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="1658iysnrhebh">
              <CheckIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-68" data-mp="1b3jquxuhxer2" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}